import { render, staticRenderFns } from "./AdmissionStandardScore.vue?vue&type=template&id=78e68f8a&"
import script from "./AdmissionStandardScore.vue?vue&type=script&lang=js&"
export * from "./AdmissionStandardScore.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionStandardScore.vue?vue&type=style&index=0&id=78e68f8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports